import React from "react";

import { Box } from "@chakra-ui/react";

import Table from "./Table";
import Group from "../../../pages/ServicosAcolhimento/Visualizar/Group";

export const Planejamento = ({ data }) => {
  const columns = [
    {
      Header: "Documento",
      accessor: "documento",
      Cell: (props) => {
        return <span>{props.value}</span>;
      },
    },
    {
      Header: "Data de última atualização/apresentação",
      accessor: "data",
      Cell: (props) => {
        return <span>{props.value}</span>;
      },
    },
  ];

  return data ? (
    <Box display="block">
      <Box className="break-page">
        <Group
          title="Planejamento do serviço"
          bgColor="#DDEBEA"
          mt="15px"
          py="12px"
          mtDivider="5px"
        >
          <Table data={data} columns={columns} />
        </Group>
      </Box>
    </Box>
  ) : (
    <Box className="break-page">
      <Group
        bgColor="#DDEBEA"
        title="Planejamento do serviço"
        mt="15px"
        py="12px"
        mtDivider="5px"
      />
    </Box>
  );
};
